import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function About() {
    const [companyInfo, setCompanyInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('https://api.rvssoy.com/company/read.php')
            .then(response => response.json())
            .then(data => {
                setCompanyInfo(data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching company info:', error);
                setLoading(false);
            });
    }, []);

    const getImageUrl = (imgName) => {
        if (!imgName) return '/images/resource/about-us.png';
        if (imgName.startsWith('http')) return imgName;
        return `/${imgName.startsWith('/') ? imgName.slice(1) : imgName}`;
    };

    const truncateText = (text, maxLength) => {
        if (!text) return '';
        if (text.length <= maxLength) return text;
        return text.substr(0, maxLength) + '...';
    };

    if (loading) return null;

    return (
        <section className="about-section">
            <div className="auto-container">
                <div className="row">
                    <div className="image-column col-xl-6 col-lg-5 col-md-12 col-sm-12">
                        <div className="inner-column wow fadeInLeft">
                            <div className="image-box">
                                {/* IMAGE 1 (BÖYÜK) - Ölçü verdik */}
                                <figure className="image overlay-anim wow fadeInUp">
                                    <img 
                                        src={getImageUrl(companyInfo?.image_1)} 
                                        alt="About RV Spark Solutions" 
                                        style={{ 
                                            width: '100%', 
                                            height: '550px', // Sabit hündürlük
                                            objectFit: 'cover', // Şəkli əzmədən kəsir
                                            borderRadius: '5px' // Səliqəli künclər
                                        }}
                                    />
                                </figure>
                                
                                {/* IMAGE 2 (KİÇİK) - Ölçü verdik */}
                                {companyInfo?.image_2 && (
                                    <figure className="image-2 overlay-anim wow fadeInRight">
                                        <img 
                                            src={getImageUrl(companyInfo?.image_2)} 
                                            alt="Experience" 
                                            style={{ 
                                                width: '100%', 
                                                height: '280px', // Daha kiçik hündürlük
                                                objectFit: 'cover',
                                                borderRadius: '5px'
                                            }}
                                        />
                                    </figure>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="content-column col-xl-6 col-lg-7 col-md-12 col-sm-12 wow fadeInRight" data-wow-delay="600ms">
                        <div className="inner-column">
                            <div className="sec-title">
                                <span className="sub-title">ABOUT COMPANY</span>
                                <h2>{companyInfo?.about_title || 'RV Spark Solutions Oy'}</h2>
                                <div className="text">
                                    {truncateText(companyInfo?.about_description, 350)}
                                </div>
                            </div>

                            <div className="text-block">
                                <h5>{companyInfo?.highlight_text || 'Providing reliable electrical solutions since 2024.'}</h5>
                            </div>

                            <div className="btn-box">
                                <Link to="/about-us" className="theme-btn btn-style-one">
                                    <span className="btn-title">Read More <i className="fa fa-arrow-right" /></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;